import { useReducer } from 'react';
export default function useErrorBoundaryReporter(suspense) {
    // Dispatch stays stable while the reducer checks the current rendering mode.
    const [failure, reportError] = useReducer((_previous, error) => suspense ? { error } : undefined, undefined);
    if (suspense && failure) {
        throw failure.error;
    }
    return reportError;
}
